import React, {cloneElement, useState} from 'react';
import MenuPopover from "./MenuPopover";

const MenuPopoverWrapper = ({children}) => {

    const [visiblePopover, setVisiblePopover] = useState(null)

    function handleToggle(i)
    {
        if(visiblePopover && visiblePopover === i)
        {
            setVisiblePopover(null)
        }
        else
        {
            setVisiblePopover(i)
        }
    }

    return (
        <>
            {/*DOESN'T WORK. It finds only the topmost parent*/}
            {React.Children.map(children, child => {
                if (React.isValidElement(child) && child.type === MenuPopover) {
                    return cloneElement(child, {
                        visible: visiblePopover && visiblePopover === child.props.companyId,
                        onToggle: () => handleToggle(child.props.companyId)
                    });
                }
                return child;
            })}
        </>
    );
};

export default MenuPopoverWrapper;